// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs-container {
  height: 100%;
}
.tabs-container .k-tabstrip {
  height: 100%;
}
.tabs-container .k-tabstrip-content {
  height: 100%;
  overflow-y: hidden;
}
.tabs-container .k-animation-container {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}
.tabs-container .k-animation-container .k-child-animation-container,
.tabs-container .k-animation-container .k-child-animation-container > div {
  height: 100%;
}
.tabs-container .k-animation-container .k-child-animation-container .active_tabstrip,
.tabs-container .k-animation-container .k-child-animation-container > div .active_tabstrip {
  height: 100%;
}
.tabs-container .k-tabstrip-items-wrapper {
  border-left: none !important;
  border-right: none !important;
}
.tabs-container .k-tabstrip-items-wrapper .k-item {
  background-color: #E9EBEC;
  border-radius: 0px;
  margin: 0px 1px;
}
.tabs-container .k-tabstrip-items-wrapper .k-item .k-link {
  color: #7E8A8D;
  padding: 10px 60px !important;
  font-weight: 500 !important;
  letter-spacing: 0.3px;
  font-size: 13px;
}
.tabs-container .k-tabstrip-items-wrapper .k-item.k-active {
  background-color: #ffffff;
  border-top: 3px solid #2F80ED;
  border-radius: 0px;
  margin: 0px 1px;
}
.tabs-container .k-tabstrip-items-wrapper .k-item.k-active .k-link {
  color: #000000;
  padding: 10px 60px !important;
  font-weight: 500 !important;
  letter-spacing: 0.3px;
  font-size: 13px;
}
@media (min-width: 1600px) {
  .tabs-container .k-link {
    font-size: 14px !important;
  }
}`, "",{"version":3,"sources":["webpack://./../gui/src/components/App/Styles/TabStyles.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AAAE;EACE,YAAA;AAEJ;AAAE;EACE,YAAA;EACA,kBAAA;AAEJ;AACE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AACJ;AACI;;EAEE,YAAA;AACN;AACM;;EACE,YAAA;AAER;AAGE;EACE,4BAAA;EACA,6BAAA;AADJ;AAIE;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;AAFJ;AAII;EACE,cAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,eAAA;AAFN;AAME;EACE,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;AAJJ;AAMI;EACE,cAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,eAAA;AAJN;AAQE;EACE;IACE,0BAAA;EANJ;AACF","sourcesContent":[".tabs-container {\n  height: 100%;\n  .k-tabstrip {\n    height: 100%;\n  }\n  .k-tabstrip-content {\n    height: 100%;\n    overflow-y: hidden;\n  }\n\n  .k-animation-container {\n    width: 100%;\n    height: 100%;\n    overflow-y: scroll;\n\n    .k-child-animation-container,\n    .k-child-animation-container > div{\n      height: 100%;\n\n      .active_tabstrip{\n        height: 100%;\n      }\n    }\n  }\n\n  .k-tabstrip-items-wrapper {\n    border-left: none !important;\n    border-right: none !important;\n  }\n\n  .k-tabstrip-items-wrapper .k-item {\n    background-color: #E9EBEC;\n    border-radius: 0px;\n    margin: 0px 1px;\n\n    .k-link {\n      color: #7E8A8D;\n      padding: 10px 60px !important;\n      font-weight: 500 !important;\n      letter-spacing: 0.3px;\n      font-size: 13px;\n    }\n  }\n\n  .k-tabstrip-items-wrapper .k-item.k-active {\n    background-color: #ffffff;\n    border-top: 3px solid #2F80ED;\n    border-radius: 0px;\n    margin: 0px 1px;\n\n    .k-link {\n      color: #000000;\n      padding: 10px 60px !important;\n      font-weight: 500 !important;\n      letter-spacing: 0.3px;\n      font-size: 13px;\n    }\n  }\n\n  @media (min-width: 1600px) {\n    .k-link {\n      font-size: 14px !important;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
